import React, { Component } from 'react';
import { Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { MagnifyingGlassIcon, BellIcon, QuestionMarkCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Input, Popover, PopoverTriggers, PopoverPlacements } from '@clockout-dev/design-elements';
import Inherit from '../../../core/inherit';
import withHooks from '../../../core/withHooks';
import HeaderController from './header.controller';
import styles from './styles/header.module.scss';
import NewSidebar from './NewSidebar';
import NotificationsMenu from './elements/NotificationsMenu';
import menuStyles from './styles/notificationsMenu.module.scss';

class Header extends Inherit(HeaderController, Component) {
    render() {
        const { drawerOpen, notificationsOpen, menuItems, menuLoading, menuError, unreadCount } = this.state;
        const showSearch = this.getShowSearch();
        const hasNotifications = this.hasNotifications();
        const unreadBadge = this.getUnreadBadge();

        return (
            <header className={styles.header}>
                <button className={styles.menuButton} onClick={this.handleMenuClick.bind(this)} aria-label="Menu">
                    <MenuOutlined />
                </button>
                {
                    showSearch ? 
                    (
                        <div className={styles.searchContainer}>
                            {/* TODO: wire header search — controlled value, onChange, onPressEnter, and dashboard (or global) query behavior. */}
                            <Input
                                placeholder="Search data..."
                                prefix={<MagnifyingGlassIcon className={styles.searchIcon} />}
                                classNames={{ root: styles.searchInput }}
                            />
                        </div>
                    ) : null
                }
                <div className={styles.headerRight}>
                    {this.shouldShowNotifications() ? (
                        <Popover
                            trigger={PopoverTriggers.CLICK}
                            placement={PopoverPlacements.BOTTOM_RIGHT}
                            arrow={false}
                            open={notificationsOpen}
                            onOpenChange={(open) => this.handleNotificationsOpenChange(open)}
                            classNames={{ root: menuStyles.popoverRoot }}
                            content={
                                <NotificationsMenu
                                    items={menuItems}
                                    loading={menuLoading}
                                    error={menuError}
                                    unreadCount={unreadCount}
                                    onItemClick={(item) => this.handleMenuItemClick(item)}
                                    onViewAll={() => this.handleViewAllClick()}
                                />
                            }
                        >
                            <button
                                type="button"
                                className={styles.iconButton}
                                aria-label={hasNotifications ? `Notifications, ${unreadCount} unread` : 'Notifications'}
                                aria-haspopup="menu"
                                aria-expanded={notificationsOpen}
                            >
                                <BellIcon className={styles.icon} />
                                {hasNotifications ? (
                                    <span className={styles.notificationBadge} aria-hidden="true">{unreadBadge}</span>
                                ) : null}
                            </button>
                        </Popover>
                    ) : null}
                    {this.shouldShowSupport() ? (
                        <button type="button" className={styles.iconButton} onClick={this.handleSupportClick.bind(this)} aria-label="Help">
                            <QuestionMarkCircleIcon className={styles.icon} />
                        </button>
                    ) : null}
                </div>

                <Drawer
                    placement="left"
                    onClose={this.handleDrawerClose.bind(this)}
                    open={drawerOpen}
                    className={styles.mobileDrawer}
                    width={280}
                    closable={false}
                    styles={{ header: { display: 'none' }, body: { padding: 0 } }}
                >
                    <div className={styles.drawerCloseBar}>
                        <button
                            type="button"
                            className={styles.drawerCloseButton}
                            onClick={this.handleDrawerClose.bind(this)}
                            aria-label="Close menu"
                        >
                            <XMarkIcon className={styles.drawerCloseIcon} aria-hidden />
                        </button>
                    </div>
                    <NewSidebar
                        user={this.props.user}
                        fi={this.props.fi}
                        collapsible={false}
                        classNames={{ root: styles.drawerNav }}
                    />
                </Drawer>
            </header>
        );
    }
}

export default withHooks(Header);
